// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is_updated = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_updated"), null));
  if (is_updated.TAG === /* Ok */0) {
    var wallet_balance = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wallet_balance"), null));
    if (wallet_balance.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                is_updated: is_updated._0,
                wallet_balance: wallet_balance._0
              }
            };
    }
    var e = wallet_balance._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".wallet_balance" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = is_updated._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_updated" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  t_decode ,
  
}
/* No side effect */
